function HeroSection() {
  return (
    <div className="relative flex justify-center text-white">
      <img
        src={"/images/mintnft/banner.png"}
        alt={""}
        className="max-w-[unset]  3xl:w-full w-[1920px]"
      />
      <div className="absolute left-0 top-0 w-full h-full mintnftGradient" />

      <div className="absolute flex justify-center items-center w-full h-full lg:text-[80px] text-[48px] text-green">
        <div className="flex flex-wrap justify-center">
          <span className="font-semibold">Mint</span>&nbsp;NFT's
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
